// @ts-nocheck
export function permissionOverlays() {
  if (!window.plus) return
  if (plus.os.name === 'Android') {
    if (!plus.runtime.permission?.isAuthorized(plus.runtime.permission.OVERLAY_WINDOW)) {
      plus.runtime.permission.request(
        plus.runtime.permission.OVERLAY_WINDOW,
        function () {
          ElMessage.success('悬浮窗权限已开启')
        },
        function (e) {
          ElMessage.warning('组队时，建议您在设置中开启悬浮窗权限以降低掉线重连的影响')
          // 跳转到应用设置页面
          plus.runtime.openURL('intent:#Intent;action=android.settings.APPLICATION_DETAILS_SETTINGS;data=package:' + plus.runtime.appid + ';end')
        },
      )
    } else {
      ElMessage.success('悬浮窗权限已授权')
    }
  }
}
